export interface OfficeRequirements {
  needsState: boolean;
  needsCounty: boolean;
  needsCity: boolean;
  needsDistrict: boolean;
}

export const getOfficeRequirements = (office: string): OfficeRequirements => {
  const office_lower = office.toLowerCase();
  
  // Federal Offices
  if (office_lower.includes('u.s.')) {
    return {
      needsState: true,
      needsCounty: false,
      needsCity: false,
      needsDistrict: office_lower.includes('representative')
    };
  }

  // State Offices
  if (office_lower.includes('state') || 
      office_lower.includes('governor') || 
      office_lower.includes('attorney general')) {
    return {
      needsState: true,
      needsCounty: false,
      needsCity: false,
      needsDistrict: office_lower.includes('representative') || office_lower.includes('senator')
    };
  }

  // County Offices
  if (office_lower.includes('county')) {
    return {
      needsState: true,
      needsCounty: true,
      needsCity: false,
      needsDistrict: office_lower.includes('commissioner') || office_lower.includes('supervisor')
    };
  }

  // City Offices
  if (office_lower.includes('mayor') || 
      office_lower.includes('city council') || 
      office_lower.includes('municipal')) {
    return {
      needsState: true,
      needsCounty: true,
      needsCity: true,
      needsDistrict: office_lower.includes('council')
    };
  }

  // School Board and other local offices
  if (office_lower.includes('school board') || 
      office_lower.includes('district') || 
      office_lower.includes('board member')) {
    return {
      needsState: true,
      needsCounty: true,
      needsCity: true,
      needsDistrict: true
    };
  }

  // Default - show all fields but make them optional
  return {
    needsState: true,
    needsCounty: true,
    needsCity: true,
    needsDistrict: true
  };
};